import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, ChevronDown } from 'lucide-react';
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
  const location = useLocation();
  const navGroups = [{
    label: 'Company',
    links: [{
      to: '/about',
      label: 'About Us'
    }, {
      to: '/testimonials',
      label: 'Reviews'
    }, {
      to: '/faq',
      label: 'FAQ'
    }]
  }, {
    label: 'Solutions',
    links: [{
      to: '/process',
      label: 'Our Process'
    }, {
      to: '/showroom',
      label: 'Showroom'
    }, {
      to: '/products',
      label: 'Products'
    }, {
      to: '/pricing',
      label: 'Pricing'
    }]
  }, {
    label: 'Contact',
    links: [{
      to: '/contact',
      label: 'Contact Us'
    }, {
      to: '/get-quote',
      label: 'Get Quote'
    }, {
      to: '/book',
      label: 'Book Appointment'
    }]
  }];
  return <nav className="sticky top-0 z-50 bg-alabaster/80 backdrop-blur-md border-b-3 border-charcoal px-6 py-1" data-id="element-109">
      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-110">
        <Link to="/" className="flex items-center gap-2" onClick={() => setIsOpen(false)} data-id="element-111">
          <img src="https://cdn.magicpatterns.com/uploads/28ZTKaKZzKVJqAkn3TE3hV/ChatGPT_Image_May_21,_2026,_07_24_32_PM.png" alt="NK Refacers Logo" className="h-16 md:h-20 w-auto object-contain" data-id="element-112" />
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-8 text-sm font-bold uppercase tracking-widest" data-id="element-113">
          {navGroups.map(group => <div key={group.label} className="relative group py-6" onMouseEnter={() => setActiveDropdown(group.label)} onMouseLeave={() => setActiveDropdown(null)} data-id="element-114">
              <button className="flex items-center gap-1 hover:text-espresso transition-colors" data-id="element-115">
                {group.label}
                <ChevronDown size={14} className={`transition-transform duration-300 ${activeDropdown === group.label ? 'rotate-180' : ''}`} data-id="element-116" />
              </button>

              <AnimatePresence data-id="element-117">
                {activeDropdown === group.label && <motion.div initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: 10
            }} className="absolute top-full left-0 w-56 bg-white border-3 border-charcoal shadow-xl p-4 flex flex-col gap-4" data-id="element-118">
                    {group.links.map(link => <Link key={link.to} to={link.to} className={`hover:text-espresso transition-colors ${location.pathname === link.to ? 'text-espresso' : 'text-charcoal'}`} data-id="element-119">
                        {link.label}
                      </Link>)}
                  </motion.div>}
              </AnimatePresence>
            </div>)}
          <Link to="/get-quote" className={`${location.pathname === '/get-quote' ? 'bg-espresso' : 'bg-charcoal'} text-alabaster px-6 py-3 hover:bg-espresso transition-colors ml-4`} data-id="element-120">
            Request a Quote
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden p-2 text-charcoal" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu" data-id="element-121">
          {isOpen ? <X size={32} data-id="element-122" /> : <Menu size={32} data-id="element-123" />}
        </button>
      </div>

      {/* Mobile Navigation Overlay */}
      <AnimatePresence data-id="element-124">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="absolute top-full left-0 w-full bg-white border-b-3 border-charcoal shadow-xl md:hidden overflow-y-auto max-h-[80vh]" data-id="element-125">
            <div className="flex flex-col p-8 gap-8" data-id="element-126">
              {navGroups.map(group => <div key={group.label} className="space-y-4" data-id="element-127">
                  <h3 className="text-xs font-black uppercase tracking-[0.2em] text-charcoal/30 border-b border-charcoal/10 pb-2" data-id="element-128">
                    {group.label}
                  </h3>
                  <div className="flex flex-col gap-4" data-id="element-129">
                    {group.links.map(link => <Link key={link.to} to={link.to} className={`text-2xl font-bold uppercase tracking-tight ${location.pathname === link.to ? 'text-espresso' : 'text-charcoal'} hover:text-espresso transition-colors`} onClick={() => setIsOpen(false)} data-id="element-130">
                        {link.label}
                      </Link>)}
                  </div>
                </div>)}
              <Link to="/get-quote" className={`${location.pathname === '/get-quote' ? 'bg-espresso' : 'bg-charcoal'} text-alabaster py-5 text-center font-bold uppercase tracking-widest hover:bg-espresso transition-colors`} onClick={() => setIsOpen(false)} data-id="element-131">
                Request a Quote
              </Link>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}